import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class ServicePatternsStructurePageStore extends ComponentStoreV2Factory {

    public structure = computed(() => this.data.getServicePatterns()?.items?.[0] || null);

}
